import { render, staticRenderFns } from "./ProductTagForm.vue?vue&type=template&id=f27d3c38"
import script from "./ProductTagForm.vue?vue&type=script&lang=js"
export * from "./ProductTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports